<template>
  <div class="findPwdWin">
    <div class="page_win forget" v-if="isFind">
      <div class="topContent">
        <div class="topContent_l" @click="back">
          <img :src="returnRightImg" alt="" />
        </div>
        <div class="topContent_m">
          <span>忘记密码</span>
        </div>
      </div>
      <div class="bottomContent">
        <div class="view_group">
          <div class="view_group_l">
            <div class="view_group_img">
              <img :src="accountImg" alt="" />
            </div>
            <input
              placeholder-style="color:#999"
              type="text"
              name="newAcount"
              v-model="newAcount"
              placeholder="请输入你的账号"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="view_group">
          <div class="view_group_l">
            <div class="view_group_img">
              <img :src="phoneImg" alt="" />
            </div>
            <input
              onkeyup="this.value=this.value.replace(/\D/g,'')"
              onafterpaste="this.value=this.value.replace(/\D/g,'')"
              placeholder-style="color:#999"
              type="text"
              maxlength="11"
              name="findPhone"
              v-model="findPhone"
              placeholder="请输入绑定的手机号码"
              autocomplete="off"
            />
          </div>
        </div>

        <div class="view_group">
          <div class="view_group_l">
            <div class="view_group_img">
              <img :src="codeImg" class="code_img" alt="" />
            </div>
            <input
              class="codeInput"
              maxlength="6"
              placeholder-style="color:#999"
              type="text"
              name="newCode"
              v-model="newCode"
              placeholder="请输入验证码"
              autocomplete="off"
            />
          </div>

          <div
            class="getcodeAll selectColor"
            @click="getForgetCode"
            :disabled="countdownNew < 60 && countdownNew >= 1"
          >
            {{
              countdownNew < 60 && countdownNew >= 1
                ? `${countdownNew}秒后可重发`
                : "获取验证码"
            }}
          </div>
        </div>
        <div class="view_group">
          <div class="view_group_l">
            <div class="view_group_img">
              <img :src="passImg" alt="" />
            </div>
            <input
              placeholder-style="color:#999"
              maxlength="10"
              type="password"
              name="newPass"
              v-model="newPass"
              placeholder="请输入新的密码"
              autocomplete="off"
            />
          </div>
        </div>
        <div class="view_group">
          <div class="view_group_l">
            <div class="view_group_img">
              <img :src="passImg" alt="" />
            </div>
            <input
              placeholder-style="color:#999"
              maxlength="10"
              type="password"
              name="newPassConfirm"
              v-model="newPassConfirm"
              placeholder="请确认新密码"
              autocomplete="off"
            />
          </div>
        </div>
      </div>
      <div class="bot_btn" @click="resetPass">确认重置</div>
    </div>
  </div>
</template>
<script>
import { hex_md5 } from "@/common/js/md5.js";
import fun from "@/common/js/common.js";
export default {
  name: "register",
  inject: ["reload"], //注入App里的reload方法
  data() {
    return {
      isFind: true,
      isRet: true,
      userInfo: "",
      daid: "",
      findPhone: "",
      newAcount: "",
      newCode: "",
      countdownNew: "",
      newPass: "",
      newPassConfirm: "",
      returnRightImg: require("../../assets/img/new2/back.png"),
      accountImg: require("../../assets/img/view6/account.png"),
      phoneImg: require("../../assets/img/view6/phone.png"),
      codeImg: require("../../assets/img/view6/code.png"),
      close_icon2: require("../../assets/img/view6/close2.png"),
      passImg: require("../../assets/img/view6/pwd.png"),
    };
  },
  created() {},
  mounted() {
    this.userInfo =
      localStorage.getItem("userInfo") &&
      localStorage.getItem("userInfo") != "undefined"
        ? JSON.parse(localStorage.getItem("userInfo"))
        : {};
    this.adid = localStorage.getItem("adid")
      ? localStorage.getItem("adid")
      : fun.getQueryString("adid");
  },
  methods: {
    back() {
      this.$store.dispatch("IsFindPwdFun", false);
      this.$store.dispatch("IsLoginBoxFun", true);
    },
    close() {
      this.$store.dispatch("IsFindPwdFun", false);
    },
    resetPass() {
      if (!this.newAcount) {
        this.$toast.text("请输入你的账号");
        return false;
      } else if (!this.findPhone) {
        this.$toast.text("请输入手机号");
        return false;
      } else if (!/^1(3|4|5|7|8|9)\d{9}$/.test(this.findPhone)) {
        this.$toast.text("手机号码有误，请重新输入");
        return false;
      } else if (!this.newPass) {
        this.$toast.text("请输入密码");
        return false;
      } else if (this.newPassConfirm != this.newPass) {
        this.$toast.text("请确认两次密码输入一致");
        return false;
      }
      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + this.adid + time
      );
      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        uname: this.newAcount,
        phone: this.findPhone,
        code: this.newCode,
        pwd: this.newPassConfirm,
        reg_type: "1",
        os: this.$store.state.deviceData.os,
      };
      this.$http.post(fun.apiUrl + "api/member/reset", data).then(
        function (res) {
          console.log(res);
          if (res.body.code === 200) {
            this.$toast.text(res.body.msg);
            this.isPassLogin = false;
            localStorage.setItem("userInfo", JSON.stringify(res.body.data));
            // localStorage.setItem("userInfo", JSON.stringify(res.body.data));
            // // 注册成功后存储用户信息
            // window.location.reload();

            // localStorage.removeItem("userInfo");
            this.reload();
            // localStorage.setItem("userInfo", JSON.stringify(res.body.data));
          } else {
            this.$toast.text(res.body.msg);
          }
        },
        function (res) {}
      );
    },

    // 忘记密码 发送验证码
    getForgetCode() {
      if (!this.findPhone) {
        this.$toast.text("请输入手机号");
        return false;
      }
      if (!/^1(3|4|5|7|8|9)\d{9}$/.test(this.findPhone)) {
        this.$toast.text("手机号码有误，请重新输入");
        return false;
      }
      // 发送验证码
      if (this.countdownNew < 60 && this.countdownNew >= 1) {
        return;
      }
      var time = new Date().getTime();
      var sign = hex_md5(
        this.userInfo.uid ? this.userInfo.uid : "" + this.adid + time
      );

      let data = {
        adid: this.adid,
        sign: sign,
        time: time,
        os: this.$store.state.deviceData.os,
        phone: this.findPhone,
      };
      this.$http.post(fun.apiUrl + "api/member/code", data).then(
        function (res) {
          this.countDownNew();
          this.$toast.text(res.body.msg);
        },
        function (res) {}
      );
    },
    countDownNew() {
      if (this.countdownNew < 60 && this.countdownNew >= 1) {
        return;
      }

      let self = this;
      self.countdownNew = 60;
      self.countdownNew -= 1;
      if (self.clear) {
        clearInterval(self.clear);
      }
      self.clear = null;
      self.clear = setInterval((_) => {
        if (self.countdownNew > 0) {
          self.countdownNew -= 1;
        } else {
          clearInterval(self.clear);
        }
      }, 1000);
    },
  },
};
</script>
<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
input {
  outline: none;
  border: none;
  background-color: transparent !important;
  color: #aaa8a8;
}
::-webkit-input-placeholder {
  color: #aaa8a8;
}
::-moz-placeholder {
  color: #aaa8a8;
} /* firefox 19+ */
:-ms-input-placeholder {
  color: #aaa8a8;
} /* ie */
input:-moz-placeholder {
  color: #aaa8a8;
}
.findPwdWin {
  @include flex_box(column, none, stretch);
}
.topContent {
  height: 0.68rem;
  @include flex_box(row, space-between, stretch);
  position: relative;
}
.topContent_l,
.topContent_m {
  @include flex_box(row, center, center);
}
.topContent_l {
  position: absolute;
  top: 0;
  left: 0;
  justify-content: flex-start;
  width: 0.8rem;
  height: 0.68rem;
  img {
    height: 0.32rem;
    width: auto;
  }
}
.topContent_m {
  flex: 1;
  span {
    font-size: 0.38rem;
    font-weight: 600;
    letter-spacing: 2px;
    color: #ff913a;
    line-height: 0.68rem;
  }
}
.bottomContent {
  @include flex_box(column, none, stretch);
}
.view_group {
  position: relative;
  padding-right: 0.22rem;
  border-radius: 0.1rem;
  margin-top: 0.1rem;
  height: 0.82rem;
  @include flex_box(row, space-between, center);
  border: 1px solid #ff913a;
}

.getcodeAll,
.forgetPass {
  height: 0.48rem;
  background: #ff913a;
  color: #ffffff;
  border-radius: 0.1rem;
  font-size: 0.22rem;
  padding: 0 0.16rem;
  @include flex_box(row, center, center);
}
.view_group_img {
  width: 0.8rem;
  height: 100%;
  @include flex_box(row, center, center);
  img {
    width: 0.3rem;
    height: auto;
    margin: 0;
  }
  .code_img {
    width: 0.36rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/view8/findPwd.vue